import { useState, useCallback } from "react";

export const useWeeklySummary = (BACKEND_URL, projectId) => {
  const [weeklySummary, setWeeklySummary] = useState({});
  const [loadingWeekly, setLoadingWeekly] = useState({});
  
  const fetchWeeklySummary = useCallback(async (owner, repo) => {
    const key = `${owner}/${repo}`;
    setLoadingWeekly((p) => ({ ...p, [key]: true }));
    try {
      const res = await fetch(
        `${BACKEND_URL}/github/repos/${owner}/${repo}/${projectId}/analytics/weekly/?range=7d`,
        { credentials: "include" }
      );
      const data = await res.json();
      if (data?.success) {
        setWeeklySummary((p) => ({ ...p, [key]: data }));
      }
    } finally {
      setLoadingWeekly((p) => ({ ...p, [key]: false }));
    }
  }, [BACKEND_URL, projectId]);

  return { weeklySummary, loadingWeekly, fetchWeeklySummary };
};
